import type { CSSProperties } from 'react';
import { styled, TextareaAutosize } from '@mui/material';

export const Wrapper = styled('div')(() => ({ width: '100%', position: 'relative' as const }));

export const StyledTextArea = styled(TextareaAutosize, {
  shouldForwardProp: (prop) =>
    !['background', 'error', 'lightError', 'fullWidth', 'minHeight', 'borderStyles', 'hasAdornment'].includes(prop as string),
})<{
  background?: 'transparent' | 'white';
  error?: boolean;
  lightError?: boolean;
  fullWidth?: boolean;
  minHeight?: string | null;
  borderStyles?: CSSProperties;
  hasAdornment?: boolean;
}>(({ theme, background = 'transparent', fullWidth, error, lightError, minHeight, borderStyles, hasAdornment }) => ({
  backgroundColor: error && !lightError ? theme.palette.error.light : background === 'transparent' ? 'transparent' : theme.palette.common.white,
  borderRadius: '4px',
  border: `1px solid ${error || lightError ? theme.palette.error.main : theme.palette.secondary.main}`,
  ...borderStyles,
  minWidth: fullWidth ? '100%' : '185px',
  width: '100%',
  minHeight: minHeight ? minHeight : minHeight === undefined ? '100px' : undefined,
  fontSize: '14px',
  padding: '5px',
  ...(hasAdornment && { paddingLeft: '32px' }),
  [theme.breakpoints.up('md')]: {
    padding: '10px',
    ...(hasAdornment && { paddingLeft: '40px' }),
  },
  '&:focus': {
    outline: `0px solid ${theme.palette.primary.main}`,
    borderColor: error || lightError ? theme.palette.error.main : theme.palette.secondary.main,
  },
}));

export const StartAdornment = styled('div')({
  position: 'absolute',
  top: '10px',
  left: '10px',
  display: 'flex',
  alignItems: 'center',
  pointerEvents: 'none',
});

export const InputWrapper = styled('div')({ position: 'relative', width: '100%' });
